// @ts-nocheck
import OrderDetailsTotalState from "@store/Framework/Store/Bunzl/Components/OrderDetailsTotal/OrderDetailsTotalState";
import { OrderDetailsTotalPrinOptionParameter } from "@store/Framework/Store/Bunzl/Components/OrderDetailsTotal/OrderDetailsTotalTypes";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { Draft } from "immer";

const initialState: OrderDetailsTotalState = {
    hidePriceOnPrint: false,
};

const actions = {
    "Store/Components/OrderDetailsTotal/SetPrintOption": (
        draft: Draft<OrderDetailsTotalState>,
        action: { parameter: OrderDetailsTotalPrinOptionParameter },
    ) => {
        draft.hidePriceOnPrint = action.parameter ?? false;
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type BunzlComponentsOrderDetailsTotalActions = Parameters<typeof reducer>[1];
export default reducer;
